<template>
	<div class="home">
		<div class="wrap-container">
			<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/aboutIntroduce' }">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item>帮助中心</el-breadcrumb-item>
			</el-breadcrumb>

			<!-- 头部盒子 -->
			<div class="search-box">
				<div class="box-title">请输入你要查找的问题</div>
				<div class="box-search">
					<el-input
						placeholder="搜索关键字寻找帮助"
						suffix-icon="el-icon-search"
						v-model="input1"
						@input="inputChange"
					>
					</el-input>
				</div>
			</div>

			<!-- 搜索内容 -->
			<div class="search_content" v-if="searchSatate" key="search_content">
				<el-tabs v-model="activeName2" @tab-click="handleClick" :stretch="true">
					<el-tab-pane label="智能疑问" name="4"></el-tab-pane>
					<el-tab-pane label="平台规则" name="3"></el-tab-pane>
					<el-tab-pane label="法律条文" name="5"></el-tab-pane>
					<el-tab-pane label="常见问题" name="1"></el-tab-pane>
					<el-tab-pane label="通知公告" name="2"></el-tab-pane>
				</el-tabs>

				<div class="line"></div>

				<div class="content_box">
					<!-- <div class="content_item" v-for="item in dataList" :key="item.id"> -->
					<div class="content_item0" v-if="searchData.length != 0 ? true : false">
						<div class="content_item" v-for="item in searchData" :key="item.id">
							<div class="item_title" v-html="item.name">
								<!-- <span style="color: #e60000;">账号</span>无法接收验证短信/邮件，怎么办？ -->
							</div>
							<div class="item_txt">
								<span class="s1">
									{{ item.content }}
								</span>
								<span
									class="s2"
									@click="gohelpDetails(item.id, activeName2 == '4' ? '2' : undefined)"
									>查看详情<i class="el-icon-arrow-right"></i
								></span>
							</div>
						</div>

						<!-- 分页 -->
						<div class="notice-box-bottom" v-show="search_total">
							<el-pagination
								@current-change="searchChange1"
								:page-size="5"
								small
								layout="prev, pager, next"
								:total="search_total"
							>
							</el-pagination>
						</div>
					</div>

					<!-- 暂无搜索结果 -->
					<div class="content_item result" v-else>
						<img src="@/assets/imgs/search_result.png" />
						<div class="search_result_txt">暂无搜索结果</div>
					</div>
				</div>
			</div>

			<!-- 中间盒子 -->
			<div class="help-box" v-show="!searchSatate">
				<!-- 智能问题 -->
				<div class="help-box-item">
					<div class="box-item-title">智能问题</div>
					<div class="box-item-list">
						<div
							@click="gohelpDetails(item.id, 0, '智能问题')"
							v-for="(item, index) in mesg.doubt"
							:key="item.id"
							class="item-list-text"
						>
							{{ index | wordChange }}、 {{ item.name }}
						</div>
					</div>
				</div>

				<!-- 平台规则 -->
				<div class="help-box-item">
					<div class="box-item-title">平台规则</div>
					<div class="box-item-list">
						<div
							@click="gohelpDetails(item.id, 0, '平台规则')"
							v-for="(item, index) in mesg.rule"
							:key="item.id"
							class="item-list-text"
						>
							{{ index | wordChange }}、 {{ item.name }}
						</div>
					</div>
				</div>

				<!-- 法律条文 -->
				<div class="help-box-item">
					<div class="box-item-title">法律条文</div>
					<div class="box-item-list">
						<div
							@click="gohelpDetails(item.id, 0, '法律条文')"
							v-for="(item, index) in mesg.law"
							:key="item.id"
							class="item-list-text"
						>
							{{ index | wordChange }}、 {{ item.name }}
						</div>
					</div>
				</div>
			</div>
			<!--  -->

			<!-- 底部盒子 -->
			<div class="post-box" v-show="!searchSatate">
				<!-- 常见问题 -->
				<div class="post-box-item">
					<div class="box-item-title">常见问题</div>
					<div class="box-item-list">
						<div
							@click="gohelpDetails(item.id, 0, '常见问题')"
							v-for="(item, index) in question.list"
							:key="item.id"
							class="item-list-text"
						>
							<span>{{ index | wordChange }}、 {{ item.name }}</span>
						</div>
					</div>
					<div class="box-page-btn">
						<el-pagination
							@current-change="currentChange"
							small
							layout="prev, pager, next"
							:page-size="5"
							:total="question.total"
						>
						</el-pagination>
					</div>
				</div>
				<!-- 通知公告 -->
				<div class="notice-box">
					<div class="notice-box-header">
						<div class="box-header-title">通知公告</div>
						<div class="box-header-type">
							<div class="header-type-box">
								<el-tabs>
									<el-tab-pane v-for="(item, index) in noticeType" :key="index">
										<div
											slot="label"
											:class="[status - 1 == index ? 'redColor font-w-600' : '']"
											@click="navNtice(index)"
										>
											{{ item }}
										</div>
									</el-tab-pane>
								</el-tabs>
							</div>
							<div class="header-type-btn" @click="signReadChange"> 标记为已读 </div>
						</div>
					</div>
					<div class="notice-box-body" v-if="noticList.length != 0">
						<div
							@click="gohelpDetails(item.id, 2, '通知公告')"
							v-for="item in noticList"
							:key="item.id"
							class="box-body-box"
						>
							<div :class="['box-body-title', item.read_status == '0' ? 'redColor' : '']">
								[{{ item.read_status == '0' ? '未读' : '已读' }}]
								{{ item.name }}
							</div>
							<div class="box-body-time">{{ item.createtime }}</div>
						</div>
					</div>
					<div class="notice-box-body" v-else>
						<div class="notic_news">暂无公告信息</div>
					</div>
					<div class="notice-box-bottom" v-show="notic.total">
						<el-pagination
							@current-change="currentChange1"
							:page-size="5"
							:current-page="noticePage"
							layout="prev, pager, next"
							:total="notic.total"
							small
						>
						</el-pagination>
					</div>
				</div>
			</div>
			<!--  -->
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	/**
	 * $aboutOut  智能问题,平台规则,法律条文
	 * $getProblem  常见疑问
	 * $getNotice  通知公告
	 * $getSearch  搜索
	 * $mySignRead  标记为已读
	 * $getSearchType 搜索类型
	 */
	import {
		$aboutOut,
		$getProblem,
		$getNotice,
		$getSearch,
		$mySignRead,
		$getSearchType,
	} from '@/api/index';
	export default {
		name: 'Home',
		data() {
			return {
				input1: '',
				mesg: {},
				question: {},
				page: '',
				notic: {},
				noticList: [],
				noticeType: ['全部', '已读', '未读'],
				status: 1,
				status: 1,
				throttleState: true, // 节流状态

				// 公告页标
				noticePage: 1,

				timer: null, //
				search_tabs: '', // 记录导航页
				searchSatate: false, // 是否显示搜索结果元素
				activeName2: '1',
				searchData: [],
				search_total: '',
			};
		},
		created() {
			this.aboutOut();
			this.getProblem();
			this.getNotice();
		},
		methods: {
			navNtice(e) {
				this.noticePage = 1;
				this.status = e + 1;
				this.getNotice();
			},
			currentChange1(e) {
				this.noticePage = e;
				this.getNotice();
			},
			currentChange(e) {
				this.page = e;
				this.getProblem();
			},
			// 跳转
			gohelpDetails(id, e, title) {
				// this.$router.push({
				//   name: "helpDetails",
				//   params: { id: id, type: e, title },
				// }); // 只能用 name

				this.$router.push({
					path: '/helpDetails',
					query: { id: id, type: e, title },
				});
			},
			getNotice() {
				let data = {
					page: this.noticePage,
					limit: 5,
					status: this.status,
				};
				$getNotice(data)
					.then((res) => {
						// console.log('公告信息', res);
						this.notic = res.data;
						this.noticList = res.data.list;
					})
					.catch((res) => {
						console.log(res);
					});
			},
			// 获取轮播图
			aboutOut() {
				let that = this;
				$aboutOut()
					.then((response) => {
						// console.log('获取轮播图', response);
						this.mesg = response.data;
					})
					.catch((res) => {
						console.log(res);
					});
			},
			getProblem() {
				let data = {
					page: this.page,
					limit: 5,
				};
				$getProblem(data)
					.then((response) => {
						// console.log(response);
						this.question = response.data;
					})
					.catch((res) => {
						console.log(res);
					});
			},

			// 获取搜索类型
			getType() {
				return $getSearchType({ search: this.input1 });
			},

			// 搜索方法
			getSearch(type, page = '1') {
				let params = {
					type: type || this.activeName2,
					page,
					limit: '5',
					search: this.input1,
				};

				$getSearch(params)
					.then((res) => {
						// 获取搜索数据
						this.searchData = res.data.data;
						this.searchData.map((item) => {
							// 替换文字颜色
							let value = this.input1;
							let reg = new RegExp(value);
							item.name = item.name.replace(reg, `<span style="color: #e60000;">${value}</span>`);
						});
						this.search_total = res.data.total;
						// console.log(this.searchData);
					})
					.catch((err) => {
						console.log(err);
					});
			},

			// 搜索事件
			inputChange(value) {
				clearTimeout(this.timer);
				if (!value) {
					this.searchSatate = false;
					this.searchData = [];
					return;
				}

				if (!value.trim()) return;
				this.timer = setTimeout(() => {
					this.searchSatate = true;
					this.input1 = value.trim();

					this.getType()
						.then((res1) => {
							// 获取搜索类型
							// console.log('获取搜索类型', res1);
							this.activeName2 = res1.data.type[0] + '' || '1';
							this.search_tabs = res1.data.type[0] + '' || '1';
							this.getSearch();
						})
						.catch((err) => {
							console.log(err);
						});
				}, 600);
			},

			// 搜索 分页
			searchChange1(e) {
				this.getSearch(this.activeName2, e + '');
			},

			// 切换导航
			handleClick(e) {
				if (e.name == this.search_tabs) return;
				this.search_tabs = e.name;

				this.getSearch(e.name + '');
			},

			// 标记为已读
			signReadChange() {
				// 节流状态 修改
				if (!this.throttleState) return;
				this.throttleState = false;

				if (this.status == 2) return;
				$mySignRead()
					.then((res) => {
						// console.log(res);
						if (res.code == 200) {
							this.$message({
								showClose: true,
								message: '标记为已读',
								type: 'success',
							});
						}
						this.getNotice();
					})
					.catch((err) => {
						console.log(err);
					});

				// 节流状态 修改
				setTimeout(() => {
					this.throttleState = true;
				}, 618);
			},
		},

		filters: {
			// 列表 序号
			wordChange(num) {
				if (num >= 100) return '';

				let str;
				let wordIndex = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
				let bits = num % 10;
				let ten = Math.floor(num / 10);
				if (num < 10) {
					str = wordIndex[num];
				} else if (num >= 10 && num < 20) {
					str = wordIndex[9] + wordIndex[bits];
				} else {
					str = wordIndex[ten - 1] + wordIndex[9] + (bits != 9 ? wordIndex[bits] : '');
				}
				return str;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.wrap-container {
		position: relative;
		box-sizing: border-box;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
		background-color: #f5f5f5;
		::v-deep .el-pager li.active {
			color: #e60000;
		}
		.bread {
			margin: calc(var(--proportion) * 40px) calc(var(--proportion) * 160px);
			margin-left: 10%;
		}
		.search-box {
			display: flex;
			width: 80%;
			margin-left: 10%;
			justify-content: center;
			align-items: center;
			margin-top: calc(var(--proportion) * -40px);
			.box-title {
				font-size: 18px;

				// font-weight: bold;
				color: #333333;
			}
			.box-search {
				width: 45%;
				margin-left: 15px;
			}
		}

		// --- 搜索内容
		.search_content {
			position: relative;
			width: 80%;
			min-height: 100vh;
			display: flex;
			flex-direction: column;
			// justify-content: center;
			align-items: center;
			padding: 15px;
			margin-top: 40px;
			margin-left: 10%;
			margin-bottom: 60px;
			color: #333333;
			font-size: 18px;

			// font-weight: bold;
			border-bottom: 1px solid #eeeeee;
			background-color: #fff;
			.content_box {
				width: 80%;
				height: 100%;
				padding-top: 54px;
				box-sizing: border-box;
				.content_item {
					padding-top: 31px;
					padding-bottom: 31px;
					border-bottom: 1px solid #eeeeee;
					img {
						margin-top: 50px;
						margin-left: 50%;
						transform: translateX(-50%);
					}
					.search_result_txt {
						text-align: center;
						font-size: 16px;

						font-weight: 400;
						color: #999999;
						line-height: 18px;
						margin-top: 10px;
						margin-bottom: 100px;
					}
				}
				.result {
					border-bottom-color: transparent;
				}
				.item_title {
					font-size: 18px;

					// font-weight: bold;
					color: #333333;
					line-height: 36px;
					margin-bottom: 15px;
					span {
						color: #e60000;
					}
				}
				.item_txt {
					font-size: 16px;

					.s1 {
						width: 997px;
						font-weight: 400;
						color: #333333;
						line-height: 32px;
					}
					.s2 {
						display: inline-block;
						vertical-align: top;
						width: 80px;
						font-weight: 400;
						color: #e60000;
						line-height: 32px;
						cursor: pointer;
					}
				}
				.notice-box-bottom {
					display: flex;
					justify-content: end;
					margin-top: 15px;
				}
			}
		}
		// ---

		.help-box {
			// 中间盒子
			width: 80%;
			margin-top: 40px;
			margin-left: 10%;
			display: flex;
			// justify-content: space-around;
			justify-content: space-between;
			&-item {
				width: 32%;
				background-color: #fff;
				.box-item-title {
					font-size: 18px;

					// font-weight: bold;
					color: #333333;
					border-bottom: 1px solid #eeeeee;
					padding: 20px 24px;
					line-height: 1;
				}
				.box-item-list {
					height: 212px;
					padding-top: 10px;
					overflow-y: scroll;
					/* 定义滚动条样式 */
					&::-webkit-scrollbar {
						/*滚动条整体样式*/
						width: 5px;
						/*高宽分别对应横竖滚动条的尺寸*/
						height: 5px;
					}

					/*定义滚动条轨道 内阴影+圆角*/
					&::-webkit-scrollbar-track {
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						border-radius: 10px;
						background-color: #ffffff;
					}
					/*定义滑块 内阴影+圆角*/
					&::-webkit-scrollbar-thumb {
						border-radius: 10px;
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						background-color: #cccccc;
					}
					.item-list-text {
						cursor: pointer;
						font-size: 14px;

						font-weight: 400;
						color: #333333;
						padding: 17px 24px;
						line-height: 1;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.post-box {
			// 底部盒子
			width: 80%;
			margin-top: 40px;
			display: flex;
			margin-left: 10%;
			justify-content: space-between;
			margin-bottom: 60px;
			.post-box-item {
				background-color: #fff;
				width: 32%;
				.box-item-title {
					font-size: 18px;
					line-height: 1;
					// font-weight: bold;
					color: #333333;
					padding: 20px 24px;
					border-bottom: 1px solid #eeee;
				}
				.box-item-list {
					min-height: 321px;
					overflow-y: scroll;
					/* 定义滚动条样式 */
					&::-webkit-scrollbar {
						/*滚动条整体样式*/
						width: 5px;
						/*高宽分别对应横竖滚动条的尺寸*/
						height: 5px;
					}

					/*定义滚动条轨道 内阴影+圆角*/
					&::-webkit-scrollbar-track {
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						border-radius: 10px;
						background-color: #ffffff;
					}
					/*定义滑块 内阴影+圆角*/
					&::-webkit-scrollbar-thumb {
						border-radius: 10px;
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						background-color: #cccccc;
					}
					.item-list-text {
						color: #333333;
						font-size: 14px;

						font-weight: 400;
						margin: 0px 20px;
						padding: 20px 0;
						line-height: 1;
						border-bottom: 1px solid #eeee;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						span {
							cursor: pointer;
						}
					}
				}
				.box-page-btn {
					margin: 15px 24px;
					display: flex;
					align-items: center;
					justify-content: end;
				}
			}
			// 通知公告
			.notice-box {
				width: 66%;
				background-color: #fff;
				.notice-box-header {
					position: relative;
					display: flex;
					justify-content: space-between;
					align-items: center;
					.box-header-title {
						padding: 20px 24px;
						font-size: 18px;
						line-height: 1;
						// font-weight: bold;
						color: #333333;

						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.box-header-type {
						display: flex;
						// align-items: center;
						margin-right: 35px;
						.header-type-box {
							// padding-top: 6px;
							// margin-top: -5px;
						}
						.header-type-btn {
							position: relative;
							z-index: 999;
							cursor: pointer;
							font-size: 14px;

							font-weight: 400;
							width: 94px;
							height: 32px;
							border: 1px solid #e60000;
							border-radius: 2px;
							line-height: 32px;
							color: #e60000;
							text-align: center;
							margin-left: 40px;
							&:hover {
								color: #e62a3d;
								background: #eeeeeea2;
							}
						}
					}
				}
				.notice-box-body {
					min-height: 321px;
					border-top: 1px solid #eeeeee;
					padding-top: 10px;
					overflow-y: scroll; /* 定义滚动条样式 */
					&::-webkit-scrollbar {
						/*滚动条整体样式*/
						width: 5px;
						/*高宽分别对应横竖滚动条的尺寸*/
						height: 5px;
					}

					/*定义滚动条轨道 内阴影+圆角*/
					&::-webkit-scrollbar-track {
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						border-radius: 10px;
						background-color: #ffffff;
					}
					/*定义滑块 内阴影+圆角*/
					&::-webkit-scrollbar-thumb {
						border-radius: 10px;
						box-shadow: inset 0 0 0px rgba(180, 180, 180, 0.5);
						background-color: #cccccc;
					}
					.box-body-box {
						border-bottom: 1px solid #eeeeee;
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 20px 0;
						margin: 0 24px;
						line-height: 1;
						.box-body-title {
							cursor: pointer;
							font-size: 14px;

							font-weight: 400;
							color: #333333;

							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.box-body-time {
							min-width: 160px;
							font-size: 16px;

							font-weight: 400;
							color: #999999;
						}
					}
					.notic_news {
						padding-top: 50px;
						box-sizing: border-box;
						text-align: center;
						font-size: 14px;
						font-weight: 400;
						color: #999999;
					}
				}
				.notice-box-bottom {
					margin: 15px 24px;
					display: flex;
					justify-content: end;
				}
			}
		}
	}

	::v-deep .el-tabs__nav-wrap::after {
		background-color: transparent !important;
		text-align: center;
	}

	::v-deep .el-tabs__item {
		font-size: 16px;

		font-weight: 500;
		color: #666666;
	}

	::v-deep .el-tabs__active-bar {
		bottom: 2px;
		// height: 4px;
		// background: #e60000;

		height: 8px;
		background: #e60000;
	}

	::v-deep {
		.el-tabs {
			width: 100%;
			justify-content: center;
		}
		// .el-tabs__header {
		//   width: 525px;
		//   position: absolute;
		//   top: 0;
		//   transform: translateX(-39%);
		// }
		.post-box {
			.el-tabs__header {
				width: 525px;
				height: 100%;
				position: absolute;
				top: 0;
				transform: translateX(-39%);
				display: flex;
				align-items: center;
			}
		}

		// 搜索导航栏
		.search_content {
			.el-tabs__header {
				width: auto;
				position: absolute;
				top: 0;
				left: 50%;
				transform: translateX(-50%);
				.el-tabs__nav-wrap,
				.el-tabs__nav-scroll {
					overflow: visible;
				}
				// 导航栏下划线
				.el-tabs__active-bar {
					// bottom: -7px;
					// height: 4px;
					// background: #e60000;

					// bottom: 2px;
					height: 8px;
					background: #e60000;
				}
				.el-tabs__nav-scroll {
					margin-top: 6px;
				}
			}
		}
		.is-active {
			// font-weight: bold;

			color: #333333;
			font-size: 16px;
		}
		// 输入框
		.el-input {
			height: 52px;
			line-height: 52px;
			.el-input__inner {
				height: 100%;
				&:focus {
					border-color: #e60000;
				}
			}
		}
	}
	::v-deep {
		.el-pagination--small {
			display: flex;
		}
	}

	.post-box {
		.box-item-list {
			padding-top: 10px;
			.item-list-text {
				color: #333333;
				font-size: 14px;

				font-weight: 400;
				margin: 15px 24px;
				padding: 6px 0px 21px;
				border-bottom: 1px solid #eeee;
				line-height: 1;
			}
		}
	}

	.redColor {
		color: #e60000 !important;
	}

	.font-w-600 {
		font-weight: 600;
	}

	.line {
		position: absolute;
		top: 10px;
		left: 0;
		width: 100%;
		height: 1px;
		margin-top: 44px;
		background: #eeeeee;
	}

	.content_item0 {
		margin-top: -15px;
	}

	.box-body-title:hover,
	.item-list-text:hover {
		color: $theme-color !important;
	}

	::v-deep {
		// 面包屑
		.el-breadcrumb__inner {
			font-size: 14px;

			font-weight: 400;
			color: #999999 !important;
			&:hover {
				color: $theme-color !important;
			}
		}

		// 分页
		.el-pager li {
			color: #999999;
			&:hover {
				color: #000;
			}
		}
		.el-pagination button:hover {
			color: $theme-color;
		}
	}
</style>
